import styled from "styled-components";

export const Container = styled.main`
  width: 100vw;
  /* height: 100vh; */

  section {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
`;
